/*! LBJ Wishlist → Instagram Story generator v1.2 */
;(() => {
  const W = 1080, H = 1920
  const LOGO_URL = '//leonbaker.com/cdn/shop/files/Leon_Baker_Logo_White.png?width=400'
  const GOLD = '#C9A96E'
  const WHITE = '#FFFFFF'
  const DIM = 'rgba(255,255,255,0.5)'
  const FONT_BODY = '"Helvetica Neue", Helvetica, Arial, sans-serif'
  const MAX_VISIBLE = 4

  function loadImg(src) {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.onload = () => resolve(img)
      img.onerror = reject
      const url = src.startsWith('//') ? 'https:' + src : src
      img.src = url
    })
  }

  function formatMoney(cents) {
    const n = Number(cents) / 100
    try {
      const ccy = window.Shopify?.currency?.active || 'AUD'
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: ccy }).format(n)
    } catch (_) {
      return `$${n.toFixed(2)}`
    }
  }

  function wrapText(ctx, text, maxWidth) {
    const words = text.split(' ')
    const lines = []
    let line = ''
    for (const word of words) {
      const test = line ? line + ' ' + word : word
      if (ctx.measureText(test).width > maxWidth && line) {
        lines.push(line)
        line = word
      } else {
        line = test
      }
    }
    if (line) lines.push(line)
    return lines
  }

  function drawRoundedRect(ctx, x, y, w, h, r) {
    ctx.beginPath()
    ctx.moveTo(x + r, y)
    ctx.lineTo(x + w - r, y)
    ctx.quadraticCurveTo(x + w, y, x + w, y + r)
    ctx.lineTo(x + w, y + h - r)
    ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h)
    ctx.lineTo(x + r, y + h)
    ctx.quadraticCurveTo(x, y + h, x, y + h - r)
    ctx.lineTo(x, y + r)
    ctx.quadraticCurveTo(x, y, x + r, y)
    ctx.closePath()
  }

  // Gold ornate divider: lines + centre diamond + flanking dots
  function drawOrnateDivider(ctx, y) {
    const cx = W / 2
    const lineLen = W * 0.28

    ctx.strokeStyle = GOLD
    ctx.lineWidth = 1
    ctx.globalAlpha = 0.45
    ctx.beginPath()
    ctx.moveTo(cx - 30, y)
    ctx.lineTo(cx - lineLen, y)
    ctx.stroke()
    ctx.beginPath()
    ctx.moveTo(cx + 30, y)
    ctx.lineTo(cx + lineLen, y)
    ctx.stroke()

    ctx.globalAlpha = 0.7
    ctx.fillStyle = GOLD
    ctx.save()
    ctx.translate(cx, y)
    ctx.rotate(Math.PI / 4)
    ctx.fillRect(-5.5, -5.5, 11, 11)
    ctx.restore()

    ctx.beginPath()
    ctx.arc(cx - 21, y, 2.5, 0, Math.PI * 2)
    ctx.fill()
    ctx.beginPath()
    ctx.arc(cx + 21, y, 2.5, 0, Math.PI * 2)
    ctx.fill()

    ctx.globalAlpha = 1
  }

  // Decorative corner-bracket inner frame
  function drawInnerFrame(ctx) {
    const pad = 44
    const arm = 72

    ctx.strokeStyle = GOLD
    ctx.lineWidth = 1.5
    ctx.globalAlpha = 0.38

    ctx.beginPath()
    ctx.moveTo(pad + arm, pad)
    ctx.lineTo(pad, pad)
    ctx.lineTo(pad, pad + arm)
    ctx.stroke()

    ctx.beginPath()
    ctx.moveTo(W - pad - arm, pad)
    ctx.lineTo(W - pad, pad)
    ctx.lineTo(W - pad, pad + arm)
    ctx.stroke()

    ctx.beginPath()
    ctx.moveTo(pad + arm, H - pad)
    ctx.lineTo(pad, H - pad)
    ctx.lineTo(pad, H - pad - arm)
    ctx.stroke()

    ctx.beginPath()
    ctx.moveTo(W - pad - arm, H - pad)
    ctx.lineTo(W - pad, H - pad)
    ctx.lineTo(W - pad, H - pad - arm)
    ctx.stroke()

    ctx.globalAlpha = 1
  }

  function drawFlowingRedBackground(ctx) {
    const base = ctx.createLinearGradient(0, 0, 0, H)
    base.addColorStop(0, '#2A0408')
    base.addColorStop(0.3, '#4A0810')
    base.addColorStop(0.5, '#5C0E16')
    base.addColorStop(0.7, '#4A0810')
    base.addColorStop(1, '#1A0205')
    ctx.fillStyle = base
    ctx.fillRect(0, 0, W, H)

    const sweep = ctx.createLinearGradient(0, 0, W, H * 0.6)
    sweep.addColorStop(0, 'rgba(122, 19, 32, 0)')
    sweep.addColorStop(0.2, 'rgba(168, 27, 37, 0.4)')
    sweep.addColorStop(0.4, 'rgba(196, 34, 46, 0.35)')
    sweep.addColorStop(0.5, 'rgba(184, 31, 40, 0.3)')
    sweep.addColorStop(0.65, 'rgba(122, 19, 32, 0.2)')
    sweep.addColorStop(0.8, 'rgba(92, 14, 22, 0.15)')
    sweep.addColorStop(1, 'rgba(74, 8, 16, 0)')
    ctx.fillStyle = sweep
    ctx.fillRect(0, 0, W, H)

    const sweep2 = ctx.createLinearGradient(W, H * 0.4, 0, H)
    sweep2.addColorStop(0, 'rgba(122, 19, 32, 0)')
    sweep2.addColorStop(0.3, 'rgba(160, 21, 36, 0.25)')
    sweep2.addColorStop(0.5, 'rgba(196, 34, 46, 0.2)')
    sweep2.addColorStop(0.7, 'rgba(122, 19, 32, 0.15)')
    sweep2.addColorStop(1, 'rgba(42, 4, 8, 0)')
    ctx.fillStyle = sweep2
    ctx.fillRect(0, 0, W, H)

    const glow = ctx.createRadialGradient(W * 0.5, H * 0.25, 0, W * 0.5, H * 0.25, W * 0.8)
    glow.addColorStop(0, 'rgba(168, 27, 37, 0.25)')
    glow.addColorStop(0.4, 'rgba(122, 19, 32, 0.1)')
    glow.addColorStop(1, 'rgba(42, 4, 8, 0)')
    ctx.fillStyle = glow
    ctx.fillRect(0, 0, W, H)

    ctx.globalAlpha = 0.025
    for (let i = 0; i < 5000; i++) {
      ctx.fillStyle = Math.random() > 0.5 ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)'
      ctx.fillRect(Math.random() * W, Math.random() * H, 1, 1)
    }
    ctx.globalAlpha = 1

    const vigL = ctx.createLinearGradient(0, 0, W * 0.15, 0)
    vigL.addColorStop(0, 'rgba(10, 2, 4, 0.6)')
    vigL.addColorStop(1, 'rgba(10, 2, 4, 0)')
    ctx.fillStyle = vigL
    ctx.fillRect(0, 0, W * 0.15, H)

    const vigR = ctx.createLinearGradient(W, 0, W * 0.85, 0)
    vigR.addColorStop(0, 'rgba(10, 2, 4, 0.6)')
    vigR.addColorStop(1, 'rgba(10, 2, 4, 0)')
    ctx.fillStyle = vigR
    ctx.fillRect(W * 0.85, 0, W * 0.15, H)
  }

  async function generateStory(products) {
    const canvas = document.createElement('canvas')
    canvas.width = W
    canvas.height = H
    const ctx = canvas.getContext('2d')

    drawFlowingRedBackground(ctx)
    drawInnerFrame(ctx)

    let logoImg
    try {
      logoImg = await loadImg(LOGO_URL)
    } catch (_) {}

    let y = 120

    if (logoImg) {
      const logoH = 65
      const logoW = logoImg.width * (logoH / logoImg.height)
      ctx.drawImage(logoImg, (W - logoW) / 2, y, logoW, logoH)
      y += logoH + 55
    }

    drawOrnateDivider(ctx, y)
    y += 58

    // Heading in gold for a more luxurious feel
    ctx.fillStyle = GOLD
    ctx.font = `300 46px ${FONT_BODY}`
    ctx.letterSpacing = '14px'
    ctx.textAlign = 'center'
    ctx.fillText('MY WISHLIST', W / 2, y)
    ctx.letterSpacing = '0px'
    y += 22

    ctx.fillStyle = DIM
    ctx.font = `300 22px ${FONT_BODY}`
    const countText = products.length === 1 ? '1 item' : `${products.length} items`
    ctx.fillText(countText, W / 2, y + 34)
    y += 80

    drawOrnateDivider(ctx, y)
    y += 62

    // Product grid — centre single items, 2-col for 2-4 items
    const items = products.slice(0, MAX_VISIBLE)
    const extraCount = products.length - MAX_VISIBLE
    const isSingle = items.length === 1
    const cols = isSingle ? 1 : 2
    const gutter = 36
    const padX = 80
    const cellW = isSingle ? Math.min(560, W - 200) : (W - padX * 2 - gutter) / cols
    const colStart = isSingle ? (W - cellW) / 2 : padX
    const imgSize = cellW
    const cellH = imgSize + 130

    const footerY = H - 180
    const gridRows = Math.ceil(items.length / cols)
    const rowGap = 28
    const gridH = gridRows * cellH + Math.max(0, gridRows - 1) * rowGap + (extraCount > 0 ? 68 : 0)
    const contentZone = footerY - y
    const gridY = y + Math.max(0, Math.floor((contentZone - gridH) / 2))

    const productImages = await Promise.allSettled(
      items.map(p => {
        const src = p.images?.[0] || p.featured_image || ''
        if (!src) return Promise.reject()
        const sized = src.includes('?') ? src + '&width=400' : src + '?width=400'
        return loadImg(sized)
      })
    )

    ctx.textAlign = 'center'

    for (let i = 0; i < items.length; i++) {
      const col = i % cols
      const row = Math.floor(i / cols)
      const cx = colStart + col * (cellW + gutter)
      const cy = gridY + row * (cellH + rowGap)

      // Glass card background
      ctx.fillStyle = 'rgba(255, 255, 255, 0.045)'
      drawRoundedRect(ctx, cx - 10, cy - 10, cellW + 20, cellH + 8, 14)
      ctx.fill()
      ctx.strokeStyle = GOLD
      ctx.lineWidth = 0.75
      ctx.globalAlpha = 0.12
      drawRoundedRect(ctx, cx - 10, cy - 10, cellW + 20, cellH + 8, 14)
      ctx.stroke()
      ctx.globalAlpha = 1

      // Product image
      const imgResult = productImages[i]
      if (imgResult.status === 'fulfilled') {
        const img = imgResult.value
        ctx.save()
        drawRoundedRect(ctx, cx, cy, imgSize, imgSize, 10)
        ctx.clip()
        const scale = Math.max(imgSize / img.width, imgSize / img.height)
        const dw = img.width * scale
        const dh = img.height * scale
        ctx.drawImage(img, cx - (dw - imgSize) / 2, cy - (dh - imgSize) / 2, dw, dh)
        ctx.restore()
      } else {
        ctx.fillStyle = 'rgba(30, 5, 10, 0.6)'
        drawRoundedRect(ctx, cx, cy, imgSize, imgSize, 10)
        ctx.fill()
      }

      // Product name
      const p = items[i]
      ctx.fillStyle = WHITE
      ctx.font = `400 26px ${FONT_BODY}`
      const nameLines = wrapText(ctx, p.title, cellW - 10)
      const nameY = cy + imgSize + 34
      nameLines.slice(0, 2).forEach((line, li) => {
        ctx.fillText(line, cx + cellW / 2, nameY + li * 30)
      })

      // Price
      const v = p.variants?.find(v => v.available) || p.variants?.[0]
      if (v) {
        const priceY = nameY + Math.min(nameLines.length, 2) * 30 + 8
        ctx.fillStyle = GOLD
        ctx.font = `500 23px ${FONT_BODY}`
        ctx.fillText(formatMoney(v.price), cx + cellW / 2, priceY)
      }
    }

    // "+ X more" label
    if (extraCount > 0) {
      const moreY = gridY + gridRows * (cellH + rowGap) + 6
      ctx.fillStyle = GOLD
      ctx.font = `400 30px ${FONT_BODY}`
      ctx.textAlign = 'center'
      ctx.letterSpacing = '3px'
      ctx.fillText(`+ ${extraCount} more`, W / 2, moreY)
      ctx.letterSpacing = '0px'
    }

    // Small diamond ornament above footer line
    ctx.fillStyle = GOLD
    ctx.globalAlpha = 0.5
    ctx.save()
    ctx.translate(W / 2, footerY - 28)
    ctx.rotate(Math.PI / 4)
    ctx.fillRect(-4, -4, 8, 8)
    ctx.restore()
    ctx.globalAlpha = 1

    // Footer line
    ctx.strokeStyle = GOLD
    ctx.lineWidth = 1
    ctx.globalAlpha = 0.3
    ctx.beginPath()
    ctx.moveTo(W * 0.25, footerY)
    ctx.lineTo(W * 0.75, footerY)
    ctx.stroke()
    ctx.globalAlpha = 1

    // Website
    ctx.fillStyle = DIM
    ctx.font = `300 24px ${FONT_BODY}`
    ctx.textAlign = 'center'
    ctx.letterSpacing = '6px'
    ctx.fillText('LEONBAKER.COM', W / 2, footerY + 52)
    ctx.letterSpacing = '0px'

    // Tagline
    ctx.fillStyle = 'rgba(255,255,255,0.3)'
    ctx.font = `300 18px ${FONT_BODY}`
    ctx.letterSpacing = '3px'
    ctx.fillText('FINE JEWELLERY  ·  GERALDTON', W / 2, footerY + 90)
    ctx.letterSpacing = '0px'

    return canvas
  }

  async function shareToStory() {
    const btn = document.getElementById('wl-story-btn')
    if (btn) {
      btn.disabled = true
      btn.querySelector('.wl-story-label').textContent = 'Creating...'
    }

    try {
      const KEY = 'lbj_wishlist_v1'
      const handles = JSON.parse(localStorage.getItem(KEY) || '[]')
      if (!handles.length) {
        alert('Your wishlist is empty.')
        return
      }

      const results = await Promise.allSettled(
        handles.map(h =>
          fetch(`/products/${h}.js`, { credentials: 'same-origin' }).then(r => {
            if (!r.ok) throw new Error()
            return r.json()
          })
        )
      )
      const products = results.filter(r => r.status === 'fulfilled').map(r => r.value)
      if (!products.length) {
        alert('Could not load wishlist items.')
        return
      }

      const canvas = await generateStory(products)
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'))
      const file = new File([blob], 'leon-baker-wishlist.png', { type: 'image/png' })

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: 'My Wishlist — Leon Baker',
          text: 'Check out my wishlist from Leon Baker Fine Jewellery'
        })
      } else {
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'leon-baker-wishlist.png'
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(url)

        const toast = document.getElementById('wl-share-toast')
        if (toast) {
          toast.textContent = 'Image saved!'
          toast.classList.add('is-visible')
          setTimeout(() => {
            toast.classList.remove('is-visible')
            toast.textContent = 'Link copied!'
          }, 2500)
        }
      }
    } catch (err) {
      if (err.name !== 'AbortError') console.error('Story share error:', err)
    } finally {
      if (btn) {
        btn.disabled = false
        btn.querySelector('.wl-story-label').textContent = 'Share to Stories'
      }
    }
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('#wl-story-btn')) {
      e.preventDefault()
      shareToStory()
    }
  })

  window.LBJWishlistStory = { generate: generateStory, share: shareToStory }
})()
